import React, { useState, useEffect, useRef } from "react";
import Loader from "../loader/loader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ToastService from "../../services/toastService";
import { useGetCallLogsMutation } from "./Api";
import { FiPause, FiPlay, FiDownload, FiChevronUp, FiChevronDown } from "react-icons/fi";
import Pagination from "../Pagination/Pagination";
import { Logout, shouldLogout } from '../Common/Common'
import { useNavigate } from "react-router-dom";
import { TranscriptCell } from "./TranscriptCell";
import { KbSessionCell } from "./KbSessionCell";


const CallLogs = () => {

    const [getCallLogsApi, { isLoading }] = useGetCallLogsMutation()

    const [callLogs, setCallLogs] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [callType, setCallType] = useState('all');
    const [debouncedSearch, setDebouncedSearch] = useState(search);

    const audioRef = useRef(null);
    const [playingUrl, setPlayingUrl] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [duration, setDuration] = useState(0);
    console.log(duration, 'duration')

    const navigate = useNavigate()

    const requestIdRef = useRef(0);

    const allColumns = [
        { key: "sno", label: "S.No" },
        { key: "name", label: "Name" },
        { key: "phone", label: "Phone" },
        { key: "agentName", label: "Agent Name" },
        { key: "callType", label: "Call Type" },
        { key: "callId", label: "Call ID" },
        { key: "date", label: "Date" },
        { key: "time", label: "Time" },
        { key: "status", label: "Status" },
        { key: "duration", label: "Duration" },
        { key: "transcript", label: "Transcript" },
        { key: "kbSession", label: "KB Session" },
        { key: "recorded", label: "Recorded" },
        { key: "sentiment", label: "Sentiment" },

    ];

    const [selectedColumns, setSelectedColumns] = useState(
        allColumns.map((c) => c.key) // default all selected
    );

    const MIN_SELECT = 3;
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleColumn = (key) => {
        setSelectedColumns((prev) => {
            const isSelected = prev.includes(key);

            // prevent going below 3 selected
            if (isSelected && prev.length <= MIN_SELECT) {
                return prev;
            }

            if (isSelected) {
                return prev.filter((k) => k !== key);
            }

            return [...prev, key];
        });
    };

    //  click outside handler
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 1000); // 1000ms delay

        return () => clearTimeout(handler); // cleanup on next effect
    }, [search]);

    // useEffect(() => {
    //     getCallLogs()
    // }, [rowsPerPage, currentPage, search, callType, toDate]);

    useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearch, callType, fromDate, toDate]);

    useEffect(() => {
        const getCallLogs = async () => {
            try {

                if (audioRef.current) {
                    audioRef.current.pause();
                    audioRef.current.currentTime = 0;
                }

                const requestId = ++requestIdRef.current;

                const response = await getCallLogsApi({
                    page: currentPage,
                    limit: rowsPerPage,
                    filter: debouncedSearch,
                    callsType: callType,
                    fromDate: formatDateForAPI(fromDate),
                    toDate: formatDateForAPI(toDate)
                })

                if (requestId !== requestIdRef.current) return;

                // console.log(response?.data?.data?.logs,'response?.data?.data?.logs')

                if (response?.data?.success) {
                    setCallLogs(response?.data?.data?.logs)
                    setTotalRecords(response?.data?.data?.pagination.total || 0);
                    setTotalPages(response?.data?.data?.pagination.totalPages || 1);
                } else {
                    if (shouldLogout(response.error)) {
                        Logout(navigate);
                    }
                }
            } catch (err) {
                console.log(err, 'err')
            }
        }
        if (
            (fromDate === null && toDate === null) ||
            (fromDate !== null && toDate !== null)
        ) {
            getCallLogs();
        }
    }, [rowsPerPage, currentPage, debouncedSearch, callType, fromDate, toDate]);

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
        setPlayingUrl(null);
        setIsPlaying(false);
        setProgress(0);
    }, [currentPage, rowsPerPage, debouncedSearch, callType, fromDate, toDate]);

    const formatDateForAPI = (date) => {
        if (!date) return null;

        const offset = date.getTimezoneOffset();
        const adjustedDate = new Date(date.getTime() - offset * 60000);

        return adjustedDate.toISOString().split("T")[0]; // YYYY-MM-DD
    };





    const startEntry = totalRecords === 0
        ? 0
        : (currentPage - 1) * rowsPerPage + 1;

    const endEntry = Math.min(currentPage * rowsPerPage, totalRecords);

    const formatTime = (dateString) => {
        if (!dateString) return "-";
        return new Date(dateString).toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true, // change to false if you want 24h format
        });
    };


    const formatDate = (dateString) => {
        if (!dateString) return "-";
        return new Date(dateString).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    const formatDurationHMS = (seconds) => {
        if (!seconds) return "0:00";
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        if (h > 0) {
            return `${h}:${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
        }
        return `${m}:${s.toString().padStart(2, "0")}`;
    };



    const handlePlay = (url) => {
        if (!url) {
            ToastService.error("No recording available");
            return;
        }

        // Same audio → toggle
        if (audioRef.current && playingUrl === url) {
            if (audioRef.current.paused) {
                audioRef.current.play();
                setIsPlaying(true);
            } else {
                audioRef.current.pause();
                setIsPlaying(false);
            }
            return;
        }

        // Stop previous
        if (audioRef.current) {
            audioRef.current.pause();
        }

        const audio = new Audio(url);
        audioRef.current = audio;
        setPlayingUrl(url);
        setIsPlaying(true);

        audio.play().catch(() => {
            ToastService.error("Unable to play audio");
        });

        audio.ontimeupdate = () => {
            setProgress(audio.currentTime);
            setDuration(audio.duration || 0);
        };

        audio.onended = () => {
            setIsPlaying(false);
            setPlayingUrl(null);
            setProgress(0);
        };
    };

    // const handlePlay = (url) => {
    //     if (!url) {
    //         ToastService.error("No recording available");
    //         return;
    //     }

    //     const audio = audioRef.current;

    //     // SAME AUDIO TOGGLE
    //     if (audio && playingUrl === url) {
    //         if (audio.paused) {
    //             audio.play();
    //             setIsPlaying(true);
    //         } else {
    //             audio.pause();
    //             setIsPlaying(false);
    //         }
    //         return;
    //     }

    //     // STOP PREVIOUS AUDIO
    //     if (audio) {
    //         audio.pause();
    //     }

    //     const newAudio = new Audio(url);
    //     audioRef.current = newAudio;

    //     setPlayingUrl(url);
    //     setProgress(0);
    //     setDuration(0);

    //     newAudio.play().catch(() => {
    //         ToastService.error("Unable to play audio");
    //     });

    //     newAudio.ontimeupdate = () => {
    //         setProgress(newAudio.currentTime);
    //         setDuration(newAudio.duration || 0);
    //     };

    //     newAudio.onended = () => {
    //         setIsPlaying(false);
    //         setPlayingUrl(null);
    //         setProgress(0);
    //     };

    //     setIsPlaying(true);
    // };

    const formatAudioTime = (time) => {
        if (!time) return "0:00";
        const m = Math.floor(time / 60);
        const s = Math.floor(time % 60);
        return `${m}:${s.toString().padStart(2, "0")}`;
    };

    // remove 

    // const handleSeek = (e) => {
    //     const value = e.target.value;
    //     if (audioRef.current) {
    //         audioRef.current.currentTime = value;
    //         setProgress(value);
    //     }
    // };

    // const handleSeek = (e) => {
    //     const newTime = Number(e.target.value);

    //     if (audioRef.current) {
    //         audioRef.current.currentTime = newTime;
    //     }

    //     setProgress(newTime);
    // };

    const handleDownload = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "recording.mp3"; // customize filename
        link.click();
    };

    const handleCircleSeek = (e, url) => {
        if (!audioRef.current || playingUrl !== url) return;

        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;

        let angle = Math.atan2(y, x) + Math.PI / 2;
        if (angle < 0) angle += 2 * Math.PI;

        const percent = angle / (2 * Math.PI);

        const newTime = percent * (audioRef.current.duration || 0);

        audioRef.current.currentTime = newTime;
        setProgress(newTime);
    };

    return (
        <div>
            {isLoading ? <Loader /> :
                <div>
                    {/* Header */}
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <ul className="breadcrumb mb-0">
                                <li className="breadcrumb-item">Call logs Management</li>
                                <li className="breadcrumb-item active">Call logs</li>
                            </ul>
                        </div>
                    </div>

                    <div className="main-content">
                        <div className="row">
                            <div className="p-6">

                                {/* Title */}

                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <h3 className="h4 mb-1 drawer-header">
                                            Call logs Management
                                        </h3>
                                        <p className="mb-0 text-muted">
                                            Manage Call logs
                                        </p>
                                    </div>
                                </div>

                                <div className="card p-3 mb-4">

                                    <div className="card shadow-sm border-0 p-3 mb-4">
                                        <div className="d-flex flex-wrap gap-3 justify-content-end">
                                            {/* <div
                                                ref={dropdownRef}
                                                className="custom-dropdown"
                                            >
                                                
                                                <div
                                                    onClick={() => setOpen((prev) => !prev)}
                                                    style={{
                                                        border: "1px solid #ccc",
                                                        padding: "4px",
                                                        cursor: "pointer",
                                                        borderRadius: "4px",
                                                       
                                                    }}
                                                >
                                                    Manage Columns ({selectedColumns.length})
                                                </div>

                                            
                                                {open && (
                                                    <div className="dropdown-menu-custom"
                                                    
                                                    >
                                                        {allColumns.map((col) => {
                                                            const checked = selectedColumns.includes(col.key);
                                                            const isBlocked = checked && selectedColumns.length <= MIN_SELECT;

                                                            return (
                                                                <label
                                                                    key={col.key}
                                                                    style={{
                                                                      
                                                                        cursor: isBlocked ? "not-allowed" : "pointer",
                                                                        opacity: isBlocked ? 0.5 : 1
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={checked}
                                                                        disabled={isBlocked}
                                                                        onChange={() => toggleColumn(col.key)}
                                                                    />
                                                                    <span style={{ marginLeft: "8px" }}>{col.label}</span>
                                                                </label>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div> */}




                                            <div ref={dropdownRef} className="column-picker">

                                                <div
                                                    className="column-picker-btn"
                                                    onClick={() => setOpen((prev) => !prev)}
                                                >
                                                    <span>Manage Columns ({selectedColumns.length})</span>
                                                    <span> {open ? <FiChevronUp size={18} /> : <FiChevronDown size={18} />}</span>
                                                </div>


                                                {open && (
                                                    <div className="column-picker-menu">
                                                        {allColumns.map((col) => {
                                                            const checked = selectedColumns.includes(col.key);
                                                            const isBlocked =
                                                                checked && selectedColumns.length <= MIN_SELECT;

                                                            return (
                                                                <label
                                                                    key={col.key}
                                                                    className={`column-picker-item ${isBlocked ? "disabled" : ""
                                                                        }`}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={checked}
                                                                        disabled={isBlocked}
                                                                        onChange={() => toggleColumn(col.key)}
                                                                    />
                                                                    <span>{col.label}</span>
                                                                </label>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>






                                            {/* Date Range - Large: 20%, Small: full width */}
                                            <div className="d-flex flex-column flex-grow-1 flex-lg-grow-0" style={{ flex: "0 0 20%", minWidth: "150px" }}>

                                                {/* <label className="form-label small text-muted mb-1">Date Range</label> */}
                                                <DatePicker
                                                    selectsRange
                                                    startDate={fromDate}
                                                    endDate={toDate}
                                                    onChange={(dates) => {
                                                        const [start, end] = dates;
                                                        setFromDate(start);
                                                        setToDate(end);
                                                    }}
                                                    placeholderText="From - To Date"
                                                    className="form-control form-control-sm"
                                                    maxDate={new Date()}
                                                    dateFormat="yyyy-MM-dd"
                                                />
                                            </div>

                                            {/* Search - Large: 25%, Small: full width */}
                                            <div className="d-flex flex-column flex-grow-1 flex-lg-grow-0" style={{ flex: "0 0 25%", minWidth: "150px" }}>
                                                {/* <label className="form-label small text-muted mb-1">Search</label> */}
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Search calls by phone number or Call ID..."
                                                    value={search}
                                                    // onChange={(e) => setSearch(e.target.value)}
                                                    onChange={(e) => {
                                                        const onlyNums = e.target.value.replace(/\D/g, ""); // remove non-digits
                                                        setSearch(onlyNums);
                                                    }}
                                                />
                                            </div>

                                            {/* Call Type - Large: 20%, Small: full width */}
                                            <div className="d-flex flex-column flex-grow-1 flex-lg-grow-0" style={{ flex: "0 0 20%", minWidth: "150px" }}>
                                                {/* <label className="form-label small text-muted mb-1">Calls</label> */}
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={callType}
                                                    onChange={(e) => setCallType(e.target.value)}
                                                >
                                                    <option value="all">All Interactions</option>
                                                    <option value="inbound">Inbound Voice</option>
                                                    <option value="outbound">Outbound Voice</option>
                                                    <option value="chat">Chat</option>
                                                    <option value="email">Email</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-hover mb-0">
                                            <thead>
                                                <tr>
                                                    {allColumns.map(
                                                        (col) =>
                                                            selectedColumns.includes(col.key) && (
                                                                <th key={col.key}>{col.label}</th>
                                                            )
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!isLoading && callLogs?.length > 0 ? (
                                                    callLogs.map((item, index) => (
                                                        <tr key={index}>

                                                            {selectedColumns.includes("sno") && (
                                                                <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                                                            )}

                                                            {selectedColumns.includes("name") && (
                                                                <td>
                                                                    {item["customer.first_name"] || item["customer.last_name"] ? (
                                                                        `${item["customer.first_name"] ?? ""} ${item["customer.last_name"] ?? ""}`
                                                                            .trim()
                                                                            .replace(/\b\w/g, c => c.toUpperCase())
                                                                    ) : (
                                                                        "-"
                                                                    )}
                                                                </td>
                                                            )}
                                                            {selectedColumns.includes("phone") && (
                                                                <td>{item.direction === "inbound" ? item.from_number : item.to_number}</td>
                                                            )}
                                                            {selectedColumns.includes("agentName") && (
                                                                <td>
                                                                    {item["user.first_name"]?.charAt(0).toUpperCase() +
                                                                        item["user.first_name"]?.slice(1)}{" "}
                                                                    {item["user.last_name"]?.charAt(0).toUpperCase() +
                                                                        item["user.last_name"]?.slice(1)}{" "}
                                                                    {/* ({item["user.flexz_id"]}) */}
                                                                </td>
                                                            )}
                                                            {selectedColumns.includes("callType") && (
                                                                <td >{item.direction.charAt(0).toUpperCase() + item.direction.slice(1)}</td>
                                                            )}
                                                            {selectedColumns.includes("callId") && (
                                                                <td>{item.call_uid}</td>
                                                            )}
                                                            {selectedColumns.includes("date") && (
                                                                <td>{formatDate(item.start_time)}</td>
                                                            )}
                                                            {selectedColumns.includes("time") && (
                                                                <td>{formatTime(item.start_time)}</td>
                                                            )}
                                                            {selectedColumns.includes("status") && (
                                                                <td>{item.status.charAt(0).toUpperCase() + item.status.slice(1)}</td>
                                                            )}
                                                            {selectedColumns.includes("duration") && (
                                                                <td>{item.duration !== null && item.duration !== undefined && !isNaN(item.duration)
                                                                    ? formatDurationHMS(item.duration) + " mins"
                                                                    : "-"} </td>
                                                            )}
                                                            {/* <td>
                                                                {item.recording_url ? (
                                                                    <audio controls>
                                                                        <source src={item.recording_url} type="audio/mpeg" />
                                                                        Your browser does not support the audio element.
                                                                    </audio>
                                                                ) : (
                                                                    "No recording"
                                                                )}
                                                            </td> */}

                                                            {selectedColumns.includes("transcript") && (
                                                                <td>
                                                                    {item.conversation_json ?
                                                                        <TranscriptCell item={item.conversation_json} />
                                                                        : "-"}
                                                                </td>
                                                            )}

                                                            {selectedColumns.includes("kbSession") && (
                                                                <td>
                                                                    {item.kbSession?.length > 0 ?
                                                                        <KbSessionCell item={item.kbSession} />
                                                                        : "-"}
                                                                </td>
                                                            )}
                                                            {/* {selectedColumns.includes("kbSession") && (
                                                                <td>
                                                                    {(() => {
                                                                        console.log("kbSession:", item.kbSession);
                                                                        console.log("kbSession history:", item.kbSession[0]?.history);

                                                                        return item.kbSession?.length > 0
                                                                            ? <KbSessionCell item={item.kbSession} />
                                                                            : "-";
                                                                    })()}
                                                                </td>
                                                            )} */}

                                                            {selectedColumns.includes("recorded") && (
                                                                <td>
                                                                    {item.recording_full_url ? (
                                                                        <div className="circle-audio">


                                                                            <div className="circle-wrapper">

                                                                                {/* Hover Time */}
                                                                                <div className="circle-tooltip">
                                                                                    {playingUrl === item.recording_full_url
                                                                                        ? `${formatAudioTime(progress)} / ${formatAudioTime(item.duration)}`
                                                                                        : formatAudioTime(item.duration)}
                                                                                </div>

                                                                                <svg
                                                                                    className="circle-svg"
                                                                                    viewBox="0 0 36 36"
                                                                                    onClick={(e) => handleCircleSeek(e, item.recording_full_url)}
                                                                                >

                                                                                    {/* Background circle */}
                                                                                    <circle
                                                                                        className="circle-bg"
                                                                                        cx="18"
                                                                                        cy="18"
                                                                                        r="15.9155"
                                                                                    />

                                                                                    {/* Progress circle */}
                                                                                    <circle
                                                                                        className="circle-progress"
                                                                                        cx="18"
                                                                                        cy="18"
                                                                                        r="15.9155"
                                                                                        strokeDasharray={2 * Math.PI * 15.9155}
                                                                                        strokeDashoffset={
                                                                                            playingUrl === item.recording_full_url
                                                                                                ? (2 * Math.PI * 15.9155) -
                                                                                                ((progress || 0) / (item.duration || 1)) *
                                                                                                (2 * Math.PI * 15.9155)
                                                                                                : 2 * Math.PI * 15.9155
                                                                                        }
                                                                                    />
                                                                                </svg>


                                                                                <button
                                                                                    className={`circle-play ${playingUrl === item.recording_full_url && isPlaying ? "playing" : ""
                                                                                        }`}
                                                                                    onClick={() => handlePlay(item.recording_full_url)}
                                                                                >
                                                                                    {playingUrl === item.recording_full_url && isPlaying ? (
                                                                                        <FiPause size={14} />
                                                                                    ) : (
                                                                                        <FiPlay size={14} />
                                                                                    )}
                                                                                </button>

                                                                            </div>


                                                                            <button
                                                                                className="circle-download"
                                                                                onClick={() => handleDownload(item.recording_full_url)}
                                                                            >
                                                                                <FiDownload size={16} />
                                                                            </button>

                                                                        </div>
                                                                    ) : (
                                                                        "-"
                                                                    )}
                                                                </td>
                                                            )}
                                                            {selectedColumns.includes("sentiment") && (
                                                                <td
                                                                    style={{
                                                                        color:
                                                                            item.sentiment === "Positive"
                                                                                ? "green"
                                                                                : item.sentiment === "Negative"
                                                                                    ? "red"
                                                                                    : item.sentiment === "Neutral"
                                                                                        ? "#0782D5"
                                                                                        : "inherit",
                                                                        fontWeight: 500,
                                                                    }}
                                                                >
                                                                    {item.sentiment ? `${item.sentiment} ( ${item.sentiment_score || "-"} )` : "-"}
                                                                </td>
                                                            )}
                                                            {/* <td
                                                                className="text-primary"
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                Manage
                                                            </td> */}


                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="14" className="text-center text-muted py-4" style={{ fontStyle: "italic", backgroundColor: "#f9f9f9" }}>
                                                            No data found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        {/* Pagination */}
                                        {!isLoading && callLogs?.length > 0 && (

                                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 gap-2">

                                                <div className="d-flex align-items-center gap-1 small">

                                                    <span>Show</span>

                                                    <select
                                                        className="form-select form-select-sm page-size-select"
                                                        value={rowsPerPage}
                                                        onChange={(e) => {
                                                            setRowsPerPage(Number(e.target.value));
                                                            setCurrentPage(1);
                                                        }}
                                                    >
                                                        <option value={5}>5</option>
                                                        <option value={10}>10</option>
                                                        <option value={15}>15</option>
                                                    </select>

                                                    <span>entries</span>

                                                </div>

                                                <div className="small text-muted">
                                                    Showing {startEntry} to {endEntry} of {totalRecords} entries
                                                </div>

                                                <Pagination
                                                    currentPage={currentPage}
                                                    totalPages={totalPages}
                                                    maxPagesToShow={rowsPerPage}
                                                    onPageChange={(page) => setCurrentPage(page)}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>

    );
};

export default CallLogs;  
